<template>
    <div class="setRent_formation_box">
        <div class="inform_tit"> 
            <div @click="cancel" class='cancel_box'>
                <i class="el-icon-back myback_icon"></i> Back
            </div>
        </div>
        <template v-if="isPro">
           
            <div class="inMain_box">
                <div class="informdata_tit">Set Profit Target</div>
                <el-form :model="ruleForm" label-position="top" :hide-required-asterisk="true" :rules="rules" ref="ruleForm" label-width="100px" class="information-ruleForm">
                    <el-form-item label="Does the Rental Agreement include outgoings?">
                        <div class="checkBox_list">
                            <div class="venue_checkBox" style="margin-right: 228px;">
                                <span v-if="ruleForm.does==1" @click="ruleForm.does=0,ruleForm.increase1=''" class="venue_check"></span>
                                <span v-else class="venue_checked"></span>
                                <span class="venueCheckBox_msg" style="width:258px">Dollar Amount</span>
                            </div>
                            <div class="venue_checkBox" style="margin-right: 228px;">
                                <span v-if="ruleForm.does==0"  @click="ruleForm.does=1,ruleForm.increase2=''" class="venue_check"></span>
                                <span v-else class="venue_checked"></span>
                                <span class="venueCheckBox_msg" style="width:258px">A Percentage Of Revenue</span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="" required="">
                        <div class="checkBox_list">
                            <el-col :span="12" style="margin-right:30px">
                            <el-form-item :rules="ruleForm.does==0?[{ required: true, message: ' ', trigger: 'blur' }]:[]" ref="increase1">
                                <el-input v-model="ruleForm.increase2" maxlength="10" @blur="increase2Blur" :disabled="ruleForm.does==1" class="venueInformation_input increaseInput">
                                    <span slot="prefix" class="increaseIcon">$</span>
                                </el-input>
                            </el-form-item>
                            </el-col>
                            <el-col :span="12">
                            <el-form-item :rules="ruleForm.does==1?[{ required: true, message: ' ', trigger: 'blur' }]:[]" ref="increase2">
                                <el-input v-model="ruleForm.increase1" maxlength="6" :disabled="ruleForm.does==0" class="venueInformation_input">
                                    <span slot="suffix" class="increaseIcon">%</span>
                                </el-input>
                            </el-form-item>
                            </el-col>
                        </div>
                    </el-form-item>
    
                    <!-- <h4>Profit Threshold
                        <el-tooltip class="tooltip" effect="dark" :content="content" placement="top-start" > 
                        <el-button class="tooltip-ico"></el-button> 
                        </el-tooltip>
                    </h4>
                    <el-form-item :rules="[{ required: true, message: ' ', trigger: 'blur' }]">
                        <el-input v-model="ruleForm.threshold" maxlength="6" class="venueInformation_input">
                            <span slot="suffix" class="increaseIcon">%</span>
                        </el-input>
                    </el-form-item> -->
    
                    <el-form-item class="foot_box">
                        <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
                        <el-button @click="confirm" class="cardConBtn">Confirm</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </template>

        <template v-if="isDoneLoad && !isPro">
            <div class="error-container d-flex align-items-center justify-content-center">
                <card-unauthorized></card-unauthorized>
            </div>
        </template>

        <el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
		</el-dialog>

    </div>
</template>

<script>
import api from '../../api/api'
import cardUnauthorized from '@/components/card/unauthorized';
import freeTrialNotice from '@/components/modal/freeTrialNotice';
export default {
    data() {
        return {
            content: '',
            rules:{
                // increase1:[{ required: true, message: ' ', trigger: 'blur' }],
                // increase2:[{ required: true, message: ' ', trigger: 'blur' }],
            },
            ruleForm:{
				does:0, //单选框默认选中
				increase1:'',
				increase2:'',
                threshold: ''
            },
            isPro: false,
            isDoneLoad: false,
            venueDiscountDetailsPojo: null,
      		isTrialEnd: false,
        }
    },
    components: {
        cardUnauthorized: cardUnauthorized,
        freeTrialNotice: freeTrialNotice
    },
    created() {
        this.content = <span>When the profit target of this week is lower<br />than the threshold, there will be a risk of<br />loss.</span>
    },
    methods: {
        increase2Blur(){
            this.$refs['ruleForm'].validateField('increase2');
        },
        cancel(){
            this.$router.push({path:'/setting'})
        },
        confirm(){ 
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let pat={
                        profitTarget:Number(this.ruleForm.does==1?(this.ruleForm.increase1/100).toFixed(4):this.ruleForm.increase2), 
                        profitTargetType:this.ruleForm.does,
                        revenueTargetThreshold: Number(this.ruleForm.threshold),
                        type:1
                    }
                    api.saveTargetRoster(pat,res=>{
                        let {code,data,message}=res.data;
                        if(code==0){
                             this.$router.push({path:'/setting'})
                        }else{
                            Utils.alert('',message,'error')
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        getdetail(){
            api.getTargetRoster({},res=>{
                let {code,data,message}=res.data;
                if(code==0){
                    this.ruleForm.does=data.profitTargetType
                    this.ruleForm.does==1?this.ruleForm.increase1=(data.profitTarget*100).toFixed(2):this.ruleForm.increase2=data.profitTarget
                    this.ruleForm.threshold = data.revenueTargetThreshold ? data.revenueTargetThreshold : ''
                }else{
                    Utils.alert('',message,'error')
                }
            })
        },

        closeOrLogoutVenue(isSubscribe) {
			if (isSubscribe) {
				this.isTrialEnd = false
				return
			}
			if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
				this.$root.$emit('logout-venue')
			} else {
				const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
				if (isContUsingTrial == '0') {
				sessionStorage.setItem('isContUsingTrial', '1')
				}
				this.isTrialEnd = false
			}
		}
    },
    mounted() {
        this.getdetail()

        this.$root.$on('isPro', (isPro, others) => { 
            this.isPro = isPro
            this.isDoneLoad = true

            const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}
        })
    },
    computed: {
        nincrease1(){
            return this.ruleForm.increase1
        },
        nincrease2(){
            return this.ruleForm.increase2
        }
    },
    watch: {
        nincrease1(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.increase1 = o;
					}, 50);
				}
				if(n > 100){
					setTimeout(()=>{
						this.ruleForm.increase1=100
					},50)
				}
			}
        },
        nincrease2(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.increase2 = o;
					}, 50);
				}
			}
		}
    },
}
</script>

<style lang="scss">
    .setRent_formation_box{
        position: relative;
        .inform_tit{
            height:76px;
            font-size:14px;
            font-weight:600;
            color:var(--text-color);
            line-height:20px;
            width: 100%;
            background-color: var(--background-color);
            z-index: 100;
            .cancel_box{
                cursor: pointer;
                width: 150px;
            }
        }
        .inMain_box{
            background-color: var(--background-color-4);
            width: 100%;
            box-sizing: border-box;
            padding:50px 15%;
            .informdata_tit{
                text-align: center;
                margin-bottom: 50px;
                height:42px;
                font-size:30px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:var(--text-color);
                line-height:42px;
            }
            .checkBox_list{
                display: flex;
                height: 40px;
                align-items: center;
            }
            .venue_checkBox{
                display: flex;
                align-items: center;
                margin-right: 319px;
                .venue_check{
                    width:16px;
                    height:16px;
                    box-sizing: border-box;
                    background:rgba(43,52,68,1);
                    border-radius:50%;
                    border:1px solid rgba(95,95,95,1);
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venue_checked{
                    width:16px;
                    height:16px;
                    background: url("../../../static/img/Shape.png");
                    background-size: cover;
                    border-radius:50%;
                    background-repeat: no-repeat;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venueCheckBox_msg{
                    width: 200px;
                    height:28px;
                    font-size:20px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:var(--text-color);
                    line-height:28px;
                }
            }
            h4{
                font-size: 14px;
                font-family: SF Pro Text-Regular, SF Pro Text;
                font-weight: 400;
                color: var(--text-color);
                line-height: 16px;
                margin-bottom: 10px;
                margin-top: 23px;
                .tooltip-ico {
                    width: 20px;
                    height: 16px;
                    margin-right: 15px;
                    background-repeat: no-repeat;
                    background-position: left top;
                    background-size: 12px auto;
                    background-image: url("../../assets/qqq.png");
                    border: none;
                    background-color: transparent;
                }
            }
        }
    }
    .checked{
        color: #D13A90 !important;
	}
	.increaseIcon{
		line-height: 50px;
		font-size: 18px;
		color: var(--text-color);
		&:first-child{
			margin-right: 20px;
		}
		&:last-child{
			margin-left: 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/setting/target.vue